<template>
  <div class="tei-data-error">
    {{ message }}
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: [String, Error],
      default: null,
    },
  },
};
</script>

<style lang="stylus">
.tei-data-error {
  nebula-text-h6();
  nebula-text-semibold();

  align-items: center;
  bottom: 0;
  color: $nebula-color-white;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
}
</style>
